<template>
    <div class="p-col-12 p-md-12 p-lg-12">
        <page-header title="forms.login-page-configuration.title"/>
        <form @submit.prevent="save" v-if="form">
            <card class="p-col-12">
                <image-upload id="logo" @change="setImage($event, 'logo')" v-model="form.logo" class="p-col-12 p-md-6 p-lg-6" title="forms.login-page-configuration.logo" :cropper-options="cropperOptions" />
                <image-upload id="background-image" @change="setImage($event, 'backgroundImage')" v-model="form.backgroundImage" class="p-col-12 p-md-6 p-lg-6" title="forms.login-page-configuration.background-image" :cropper-options="cropperOptions" />
            </card>
            <div class="p-col-12">
                <Button :label="$t('btn.save&continue')" class="p-button-success" style="float: right;"/>
            </div>
        </form>
    </div>
</template>

<script>
    import PageHeader from "@/components/page/PageHeader";
    import ImageUpload from "@/components/image/ImageUpload";
    import ConfigurationBusiness from "@/business/ConfigurationBusiness";
    import ToastMessageBusiness from "@/business/ToastMessageBusiness";
    import EventBus from "@/commons/EventBus";

    export default {
        name: "LoginPageConfiguration",
        components: {ImageUpload, PageHeader},
        data(){
            return {
                form: null,
                cropperOptions: {
                    aspectRatio: 0,
                    autoCropArea: 0,
                    viewMode: 1,
                    movable: false,
                    zoomable: false
                },
            }
        },

        async mounted() {
            EventBus.loadingPage(true);
            this.form = await ConfigurationBusiness.getLoginPageConfiguration();
            EventBus.loadingPage(false);
        },

        methods:{
            save(){
                const response = ConfigurationBusiness.saveLoginPageConfiguration(this.form).catch((e) => ToastMessageBusiness.showError(e.message));
                if(response){
                    this.form = response;
                    ToastMessageBusiness.showSuccess();
                }
            },

            setImage(image, field){
                this.form[field] = image;
            }
        }
    }
</script>

<style scoped>

</style>